import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'fsFormatColor' })
export class FsFormatColorPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    // Convert underscore to space and capitalize words
    let formatted = value.replace(/_/g, ' ');

    // Capitalize first letter of each word
    formatted = formatted.replace(/\b\w/g, (char) => char.toUpperCase());

    // Replace space with '/'
    return formatted.replace(' ', '/');
  }
}
